import m from 'mithril'

export default {
  view: vnode => {
    return (
      <div className="hotspot-inner mod-title u-hotspot-fade">
        <p className="hotspot-title-text">{m.trust(vnode.attrs.hotspot.html)}</p>
      </div>
    )
  }
}
